import Screens from '../screens/';
export var GET_PROGRESSIVE_JACKPOTS_SCREENS = [Screens.Home, Screens.Favourites, Screens.Tables, Screens.VIP];